import React from 'react';

import { OverlaySpinner } from 'components/Spinner';
import { RouteFC } from 'util/routeTypes';

import { useAppStoreRedirectEffect } from 'hooks/useAppStoreRedirectEffect/useAppStoreRedirectEffect';
import { parse } from 'query-string';
import { useLocation } from '@reach/router';
import { useSmartNavigate } from 'hooks/useSmartNavigate';

export const AppMenuPage: RouteFC<{children?: never}> = () => {
  const location = useLocation();
  const navigate = useSmartNavigate();

  // extract the merchantId from the query param
  const { merchantId } = (parse(location.search) ?? {}) as Partial<{ merchantId: string }>;

  useAppStoreRedirectEffect(() => {
    // fallback to ~/:merchantId if user somehow got here w/o pop-up
    if (merchantId) {
      navigate(`~/${merchantId}`, { replace: true });

      return;
    }

    navigate('~/not-found');
  }, [merchantId]);

  return <OverlaySpinner />;
};
